export default __webpack_public_path__ + "static/media/img_9.5ec12720.JPG";